// extracted by mini-css-extract-plugin
export default {"pageWrap":"Gc-z","fullWidth":"Hc-z","heading":"Ic-z","fullBleed":"Jc-z","hidden":"Kc-z"};